import React from 'react'


export default function UiIncentiveHistoryCard(props) {


    return (
        <>
            <div className='sb-incentive-history-card'>
                <div className='sb-incentive-history-card__header'>
                    <h4>{props.heading}</h4>
                </div>
                <div className='sb-incentive-history-card__body'>
                    
                    {props.children}
                </div>
              
            </div>

        </>
    )
}
